import { gql } from '@apollo/client';

import client from '../../../core/services/graphql';

export const getUser = async (id) => {
  const query = gql`
    query User($user_id: ID!) {
      user(userId: $user_id) {
        id
        profile {
          id
          firstName
          lastName
          jobInfo
          jobCategories {
              id
            }
          educationLevel
          currentPosition {
            title
            seniority
            company {
              size
              industry
            }
          }
          linkedinFields {
            id
            emailAddress
            educationLevel
            linkedinUrl
            currentPosition {
              title
              description
              seniority
              company {
                name
                size
                industry
              }
              startDate {
                year
                month
              }
              endDate {
                year
                month
              }
            }
          }
        }
        testers {
          userInterviewsParticipantId
        }
      }
    }
  `;

  const { data } = await client.getClient().query({
    query,
    variables: {
      user_id: id,
    },
    fetchPolicy: 'network-only',
  });

  return data;
};

export const updateUserCurrentPosition = async (id, attributes) => {
  const query = gql`
    mutation UpdateUserCurrentPosition($id: ID!, $attributes: ProfileAttributes!) {
      updateUserCurrentPosition(id: $id,  attributes: $attributes) {
        profile {
          id
        }
      }
    }
  `;

  const { data } = await client.getClient().mutate({
    mutation: query,
    variables: { id, attributes },
  });

  return data;
};
